import { cltw } from '../../utils';
import { Add } from '../../icons/icons/Actions/Add';
import { Check } from '../../icons/icons/Actions/Check';
import { Info } from '../../icons/icons/Toast/info';
import clsx from 'clsx';
export enum PerksListVariant {
  BLACK = 'black',
  WHITE = 'white',
}
const iconBackground = {
  [PerksListVariant.BLACK]: 'bg-black',
  [PerksListVariant.WHITE]: 'bg-white'
};
const iconColor = {
  [PerksListVariant.BLACK]: 'white',
  [PerksListVariant.WHITE]: 'black'
};
export interface Perk {
  key: string;
  iconStyle: string;
}
export interface PerksListProps {
  perks: Perk[];
  iconSize?: number;
  className?: string;
  variant?: PerksListVariant;
}
const iconMap = (color: string) => {
  return {
    check: <Check fill={color} height={8} width={8} strokeWidth={2} />,
    plus: <Add fill={color} height={8} width={8} strokeWidth={2} />,
    info: <Info fill={color} height={14} width={14} strokeWidth={2} />
  };
};
export function PerksList({
  perks,
  iconSize = 14,
  className,
  variant = PerksListVariant.BLACK
}: PerksListProps) {
  const getIcon = (perk: Perk) => {
    if (perk.iconStyle === 'none') {
      return null;
    }
    const iconStyle = perk.iconStyle;
    const iconVariant = iconMap(iconColor[variant]);
    return iconVariant[iconStyle];
  };
  return <div className={cltw('rounded-xl', className)} data-sentry-component="PerksList" data-sentry-source-file="PerksList.tsx">
      {perks.map(perk => <ul key={perk.key} className='flex list-none items-center space-x-2 pb-1'>
          {perk.iconStyle !== 'none' ? <li className={clsx('flex items-center justify-center rounded-full', perk.iconStyle === 'info' ? 'bg-gray-a700' : iconBackground[variant])} style={{
        height: iconSize,
        width: iconSize,
        minHeight: iconSize,
        minWidth: iconSize
      }}>
              {getIcon(perk)}
            </li> : null}
          <p className={clsx('text-left text-[15px] leading-5')}>{perk.key}</p>
        </ul>)}
    </div>;
}